/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePowerpoint32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#D24726"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M17.5 12v1.5h3.75a.75.75 0 01.743.648l.007.102v7.5a.75.75 0 01-.75.75H17.5V24L10 22.687v-9.375L17.5 12zm3.75 2.25H17.5v1.7c.22-.127.477-.2.75-.2v1.5h1.5a1.5 1.5 0 01-2.25 1.3v.95h3v.75h-3v1.5h3.75v-7.5zm-7.672.75l-1.748.098v5.827l1.102.075v-2.055h.54c.15.013.3.013.45 0 .141-.021.28-.056.413-.105.258-.095.49-.246.682-.442.06-.067.114-.137.163-.21l.07-.113a1.897 1.897 0 00.285-.75 2.618 2.618 0 000-.442 2.617 2.617 0 00-.127-.87 1.5 1.5 0 00-.39-.6 1.5 1.5 0 00-.63-.338 2.715 2.715 0 00-.81-.075zm.172 1.102c.11.031.21.088.293.165a.705.705 0 01.18.285c.042.134.062.273.06.413a1.39 1.39 0 01-.06.42.75.75 0 01-.18.3.75.75 0 01-.293.188c-.13.042-.268.062-.405.06h-.413v-1.86h.45c.124-.009.248.001.368.03zM19 16.5V15a1.5 1.5 0 011.493 1.356l.007.144H19V15z"
            />
        </g>
    </AccessibleSVG>
);

export default FilePowerpoint32;
